







































































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import AdCampaignItem from '@/bundles/Ad/models/AdCampaignItem';
import { useAdCampaignItem } from '@/bundles/Ad/composables/useAdCampaignItem';
import { VForm } from '@/bundles/App/type';
import { AdCampaignItemMediaType } from '@/bundles/Ad/types';

import AdItemImage from '@/bundles/Ad/components/media-components/AdItemImage.vue';
import AdItemVideo from '@/bundles/Ad/components/media-components/AdItemVideo.vue';
import AdItemCarousel from '@/bundles/Ad/components/media-components/AdItemCarousel.vue';

export default defineComponent({
  name: 'AdItemFormBase',

  components: {
    AdItemImage,
    AdItemVideo,
    AdItemCarousel,
  },

  emits: ['ad-item:update'],

  props: {
    adItemEntry: {
      type: AdCampaignItem,
      required: true,
    },
    saveLoadingEntry: Boolean,
  },

  setup: function (props, { emit }) {
    const adItemForm = ref(null);
    const { adCampaignItem, mediaTypes } = useAdCampaignItem();
    const pickImage = ref(false);
    const files = ref<File[]>([]);

    watch(() => props.adItemEntry, function () {
      adCampaignItem.value = { ...props.adItemEntry, media: [...props.adItemEntry.media] };
      files.value = [];
      pickImage.value = false;
      resetValidation();
    }, { deep: true, immediate: true });
    watch(() => files.value, (value) => {
      if (!value.length) {
        return;
      }
      for (const file of value) {
        (function (fileEntry) {
          const reader = new FileReader();
          reader.onload = (event) => {
            if (!event?.target?.result) {
              return;
            }
            adCampaignItem.value.media.push(event?.target?.result as string);
          };
          reader.readAsDataURL(fileEntry);
        })(file);
      }
    });

    watch(() => adCampaignItem.value.media_type, () => {
      adCampaignItem.value.media = [];
    });

    function resetValidation () {
      if (!adItemForm.value) {
        return;
      }
      (adItemForm.value as unknown as VForm).resetValidation();
    }

    function submitEventHandler () {
      if (!(adItemForm.value as unknown as VForm).validate() || !adCampaignItem.value.media.length) {
        return;
      }
      emit('ad-item:update', { url: adCampaignItem.value.url, files: files.value, media_type: adCampaignItem.value.media_type });
    }

    const mediaComponentName = computed(() => {
      switch (adCampaignItem.value.media_type) {
        case AdCampaignItemMediaType.carousel:
          return 'AdItemCarousel';
        case AdCampaignItemMediaType.video:
          return 'AdItemVideo';
        default:
          return 'AdItemImage';
      }
    });

    return {
      adItemForm,
      adCampaignItem,
      pickImage,
      files,
      mediaTypes,
      mediaComponentName,
      submitEventHandler,
    };
  },
});
